import { render, staticRenderFns } from "./ResourceDirectoryTile.vue?vue&type=template&id=28e48ea8&"
import script from "./ResourceDirectoryTile.vue?vue&type=script&lang=js&"
export * from "./ResourceDirectoryTile.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDirectoryTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports